// 任务路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/activity',
  component: Layout,
  children: [
    {
      path: 'redPages/index',
      component: () => import('@/view/activity/redPages/index'),
      name: '红包'
    }
  ]
}
